import React from 'react'

const ChipStatus = ({ status, color, bgColor, border, size = 'md' }) => {
  return (
    <div
      style={{
        border: `1px solid ${border}`,
        color,
        backgroundColor: bgColor,
        borderRadius: size === 'small' ? '0.9rem' : '1.5rem',
        padding: `${size === 'small' ? '0.1rem 0.4rem' : '0.4rem 0.8rem'}`
      }}
      className={`text-${size === 'small' ? 'xs' : 'sm'}`}
    >
      {status}
    </div>
  )
}

export default ChipStatus
